import { render, staticRenderFns } from "./mallPicture.vue?vue&type=template&id=377f5317&scoped=true"
import script from "./mallPicture.vue?vue&type=script&lang=js"
export * from "./mallPicture.vue?vue&type=script&lang=js"
import style0 from "./mallPicture.vue?vue&type=style&index=0&id=377f5317&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f5317",
  null
  
)

export default component.exports